import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { find, findAll } from "utils/dom"

gsap.registerPlugin(ScrollTrigger)

export default function initSiteFooter() {
	const footer = find("footer.site-footer")
	if (!footer) return

	const mobile = window.matchMedia("(max-width: 767px)").matches
	const logo = find(".site-footer__logo", footer)
	const navLinks = findAll(".site-footer__nav li", footer)
	const social = find(".site-footer__social", footer)
	const socialLinks = findAll(".site-footer__social-grid a", footer)
	const ticket = find(".site-footer__content .btn-home-primary", footer)
	const copy = find(".site-footer__copy", footer)

	const bits = [logo, ...navLinks, social, ...socialLinks, ticket, copy].filter(Boolean)

	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
	if (reduceMotion) {
		gsap.set(bits, { opacity: 1, clearProps: "transform" })
		return
	}

	if (logo) gsap.set(logo, { opacity: 0, y: mobile ? 20 : 28, scale: 0.94 })
	gsap.set(navLinks, mobile ? { opacity: 0, y: 12 } : { opacity: 0, x: -16 })
	if (social) gsap.set(social, { opacity: 0, y: 14 })
	gsap.set(socialLinks, { opacity: 0, scale: 0.6 })
	if (ticket) gsap.set(ticket, { opacity: 0, y: 14, scale: 0.94 })
	if (copy) gsap.set(copy, { opacity: 0, y: 14 })

	ScrollTrigger.create({
		trigger: footer,
		start: mobile ? "top 85%" : "top 80%",
		once: true,
		onEnter: () => {
			const tl = gsap.timeline({ defaults: { ease: "power2.out" } })

			if (logo) {
				tl.to(
					logo,
					{ opacity: 1, y: 0, scale: 1, duration: mobile ? 0.5 : 0.65, ease: "power3.out" },
					0,
				)
			}

			if (navLinks.length) {
				tl.to(
					navLinks,
					mobile
						? { opacity: 1, y: 0, duration: 0.32, stagger: 0.06 }
						: { opacity: 1, x: 0, duration: 0.4, stagger: 0.08 },
					0.16,
				)
			}

			if (social) {
				tl.to(social, { opacity: 1, y: 0, duration: 0.35 }, 0.24)
			}

			if (socialLinks.length) {
				tl.to(
					socialLinks,
					{ opacity: 1, scale: 1, duration: 0.3, stagger: 0.05, ease: "back.out(1.5)" },
					0.32,
				)
			}

			if (ticket) {
				tl.to(
					ticket,
					{ opacity: 1, y: 0, scale: 1, duration: 0.4, ease: "back.out(1.4)" },
					0.32,
				)
			}

			if (copy) {
				tl.to(copy, { opacity: 1, y: 0, duration: 0.45 }, 0.56)
			}
		},
	})
}
